import React from "react";
import ConfettiExplosion from "react-confetti-explosion";

import BaseModal from "../BaseModal";
import { Button } from "../../ui/button";
import {
  clearSurpriseAnswer,
  loadSurpriseAnswer,
  saveSurpriseAnswer,
} from "../../../lib/local-storage";

function ViewSurpriseModal({ open = false }) {
  const pillSubmit =
    "h-10 px-4 rounded-full border border-black bg-black text-white text-sm font-semibold whitespace-nowrap leading-none hover:bg-neutral-800";

  const yesBase =
    "h-10 px-6 rounded-full border text-sm font-semibold whitespace-nowrap leading-none transition-all";
  const noBase = yesBase;

  const yesActive = "border-black bg-emerald-500 text-white hover:bg-emerald-600";
  const yesInactive = "border-neutral-300 bg-white text-neutral-400 hover:bg-neutral-100 opacity-60";
  const noActive = "border-black bg-red-500 text-white hover:bg-red-600";
  const noInactive = "border-neutral-300 bg-white text-neutral-400 hover:bg-neutral-100 opacity-60";

  const [answer, setAnswer] = React.useState(() => loadSurpriseAnswer());
  const [revealed, setRevealed] = React.useState(() => loadSurpriseAnswer() != null);

  function handleAnswer(value) {
    saveSurpriseAnswer(value);
    setAnswer(value);
  }

  return (
    <BaseModal
      title={null}
      trigger={<Button className={pillSubmit}>View Surprise</Button>}
      initiallyOpen={open}
      showActionButton={false}
    >
      <div className="grid gap-y-4 text-center">
        {!revealed && (
          <>
            <p className="text-base text-black">
              You earned a little surprise.<br/>Ready to peek?
            </p>
            <div className="flex justify-center">
              <Button
                className={pillSubmit}
                onClick={() => setRevealed(true)}
              >
                Show me
              </Button>
            </div>
          </>
        )}
        {revealed && answer !== "no" && (
          <>
            <p className="text-base text-black">
              Aloha! Nick and I are heading to Hawaii in September. 🌴
            </p>
             <p className="text-base font-semibold text-black">
              Want to come along?
            </p>
            {answer === "yes" && (
              <div className="flex justify-center">
                <ConfettiExplosion
                  particleCount={100}
                  force={0.8}
                  duration={2500}
                  zIndex={9999}
                />
              </div>
            )}
            <div className="flex gap-4 justify-center">
              <Button
                className={`${yesBase} ${
                  answer == null || answer === "yes" ? yesActive : yesInactive
                }`}
                onClick={() => handleAnswer("yes")}
              >
                Yes
              </Button>
              <Button
                className={`${noBase} ${
                  answer == null || answer === "no" ? noActive : noInactive
                }`}
                onClick={() => handleAnswer("no")}
              >
                No
              </Button>
            </div>
            {answer === "yes" && (
              <p className="text-base font-semibold text-black">
                Mahalo&#8230; that makes me happy.
              </p>
            )}
          </>
        )}
        {revealed && answer === "no" && (
          <>
            <p className="text-base text-black">
              Hmm&#8230; that&#8217;s not the answer I was hoping for.<br/>Care to think it over?
            </p>
            <div className="flex justify-center">
              <Button
                className={pillSubmit}
                onClick={() => {
                  clearSurpriseAnswer();
                  setAnswer(null);
                }}
              >
                Let me reconsider
              </Button>
            </div>
          </>
        )}
      </div>
    </BaseModal>
  );
}

export default ViewSurpriseModal;
